import logo from './logo.svg';
import './App.css';
import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

function App() {
  const form =  useRef();
  
  const [email, setName] = useState("");
  const emailList = [];

  const sendEmail = (e) => {
    e.preventDefault()
    if (emailList.includes(email)) {
      alert("You have already completed this form.")
      return null
    }else{
      emailList.push(email);
    }
    emailjs.sendForm('service_vzsbhjw', 'template_5v4y4zf', form.current, 'jg8RUPpEuucWxrNO8')
    .then((result) => {
      console.log(result.text)
      alert("Application Sent")
    }, (error) => {
      console.log(error.text);
    });
    
  };
  return (
    <div className="App">
      <header>
        Talent Search Student Support Services Program Application
      </header>
      <p>
        The Talent Search-Student Support Services program provides opportunities for academic development, assists students with college requirements,
       and serves to motivate students towards the successful completion of their post-secondary education. The program provides an interconnected series of academic support services such as study skills development, tutoring to mastering course content,
       individualized advising, career guidance, campus tours, student success workshops, financial counseling, and more.
      </p>
      <h1>
        Who is eligible for Talent Search SSS?
      </h1>
      <p>
        Eligibility for Talent Search/Student Support Services is determined by federal regulations.

        To qualify, a student must be a U.S. citizen or permanent resident and meet one or more of the following criteria:
        <ul>
          <li>Be a first-generation college student (which means that neither parent has completed a bachelor’s degree)</li>
          <li>Meet income guidelines (Total family income is below 150% of the poverty guidelines).</li>
          <li>Have documented disability status with OCC’s Office of Accessibility Resources (OAR)</li>
        </ul>
        Preference is given to students who have an intent to attend a four-year college after they graduate
      </p>
      <form ref={form} className='form' onSubmit={sendEmail}>
        <div className='info_field'>
          <label>First Name:</label>
          <input type='text' name='firstname' onChange={(e) => setName(e.target.value)} />
        </div>
        <div className='info_field'>
          <label>Last Name:</label>
          <input type='text' name='lastname' />
        </div>
        <div className='info_field'>
          <label>Address:</label>
          <input type='text' name='address' />
        </div>
        <div className='info_field'>
          <label>City:</label>
          <input type='text' name='city' />
        </div>
        <div className='info_field'>
          <label>State:</label>
          <input type='text' name='state' />
        </div>
        <div className='info_field'>
          <label>Zip:</label>
          <input type='text' name='zip' />
        </div>
        <div className='info_field'>
          <label>Phone Number:</label>
          <input type='tel' name='phone' />
        </div>
        <div className='info_field'>
          <label>Email Address:</label>
          <input type='email' name='email' onChange={(e) => setName(e.target.value)} />
        </div>
        <div className='info_field'>
          <label>Student ID Number:</label>
          <input type='number' name='studentID' />
        </div>
        <div className='info_field'>
          <label>Date of Birth:</label>
          <input type='date' name='birth' />
        </div>
        <div className='info_field'>
          <label>Are you under the age of 18:</label>
          <input type='radio' value='yes' name='age'></input> Yes
          <input type='radio' value='no' name='age'></input> No
        </div>
        <div className='info_field'>
          <label>Parent/Guardian First Name:</label>
          <input type='text' name='guardianFirst' />
        </div>
        <div className='info_field'>
          <label>Parent/Guardian Last Name:</label>
          <input type='text' name='guardianLast' />
        </div>
        <div className='info_field'>
          <label>Parent/Guardian Email:</label>
          <input type='email' name='guardianEmail' />
        </div>
        <div className='info_field'>
          <label>Are you a US Citizen:</label>
          <input type='radio' value='yes' name='citizen'></input> Yes
          <input type='radio' value='no' name='citizen'></input> No
        </div>
        <div className='info_field'>
          <label>Does your mother have a Bachelor's degree?</label>
          <input type='radio' value='yes' name='mdegree'></input> Yes
          <input type='radio' value='no' name='mdegree'></input> No
        </div>
        <div className='info_field'>
          <label>Does your father have a Bachelor's degree?</label>
          <input type='radio' value='yes' name='fdegree'></input> Yes
          <input type='radio' value='no' name='fdegree'></input> No
        </div>
        <div className='info_field'>
          <label>Do you have a documented disability with OCC's Office of Accessibility Resources?</label>
          <input type='radio' value='yes' name='occ'></input> Yes
          <input type='radio' value='no' name='occ'></input> No
        </div>
        <div className='table_container'>
          <div className='info_field_table'>
          <label>Is your total family income below the amount on the chart?</label>
            <table>
              <tr>
                <th>Size of Family</th>
                <th>Family Taxable Income</th>
              </tr>
              <tr>
                <td>1</td>
                <td>$20,385</td>
              </tr>
              <tr>
                <td>2</td>
                <td>$27,495</td>
              </tr>
              <tr>
                <td>3</td>
                <td>$34,545</td>
              </tr>
              <tr>
                <td>4</td>
                <td>$41,625</td>
              </tr>
              <tr>
                <td>5</td>
                <td>$48,705</td>
              </tr>
              <tr>
                <td>6</td>
                <td>$55,785</td>
              </tr>
              <tr>
                <td>7</td>
                <td>$62,865</td>
              </tr>
              <tr>
                <td>8</td>
                <td>$69,945</td>
              </tr>
            </table>
            
          </div>
          <p><input type='radio' value='yes' name='income'></input> Yes</p>
          <p><input type='radio' value='no' name='income'></input> No</p>
        </div>
        <div className='info_field'>
          <label>Gender:</label>
          <input type='radio' value='Male' name='gender'></input> Male
          <input type='radio' value='Female' name='gender'></input> Female
        </div>
        <div className='info_field'>
          <label>Ethnicity: Are you Hispanic/Latino?</label>
          <input type='radio' value='yes' name='ethnicity'></input> Yes
          <input type='radio' value='no' name='ethnicity'></input> No
        </div>
        <div className='info_field'>
          <label>Race?</label>
          <input type='radio' value='Black or African American' name='gender'></input> Black or African American
          <input type='radio' value='White' name='gender'></input> White
          <input type='radio' value='Native Hawaiian or Pacific Islander' name='gender'></input> Native Hawaiian or Pacific Islander
          <input type='radio' value='Asian' name='gender'></input> Asian
          <input type='radio' value='Two or more races' name='gender'></input> Two or more races
        </div>
        <div className='info_field'>
          <label>Enrolled at OCC?</label>
          <input type='radio' value='yes' name='occEnrolled'></input> Yes
          <input type='radio' value='no' name='occEnrolled'></input> No
        </div>
        <div className='info_field'>
          <label>Are you in your first or secound year?</label>
          <input type='text' name='year' />
        </div>
        <div className='info_field'>
          <label>What program are you in?</label>
          <input type='text' name='program' />
        </div>
        <div className='info_field'>
          <label>Do you plan to transfer to a university? (4 year institution)</label>
          <input type='radio' value='yes' name='transfer'></input> Yes
          <input type='radio' value='no' name='transfer'></input> No
        </div>
        <div className='info_field'>
          <label>Advisor First Name</label>
          <input type='text' name='advisorFirst' />
        </div>
        <div className='info_field'>
          <label>Advisor Last Name</label>
          <input type='text' name='advisorLast' />
        </div>
        <div className='info_field'>
          <label>High School Name/GED Program</label>
          <input type='text' name='gedProgram' />
        </div>
        <div className='info_field'>
          <label>Location of your High School/GED Program:</label>
          <input type='text' name='locationProgram' />
        </div>
        
        
        <div className='info_field'>
          <input type='submit' className='submit_btn' value="Send" />
        </div>
      </form>
      <p>
      By submitting this form, I hereby certify that this information is correct to the best of my knowledge. With my signature, 
      I am granting all Talent Search SSS personnel access to the information contained on this form and in the OCC system 
      (i.e., transcripts/registration information, grades, placement scores, and more) for the purpose of program, recording, tracking,
       and reporting as required by the U.S. Department of Education. In addition, I allow OCC Talent Search personnel to track my educational progress
        as they relate to the Talent Search program using phone, email, or other digital mediums.
      </p>
    </div>
  );
}

export default App;
